const SelectType = {
    Default: 0,
    Teams: 1,
}

export default SelectType